module.exports = __webpack_public_path__ + "media/icons/clock-icon-5f85bc49.svg";